import React from 'react'

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="main-section center-align">
      <div className="container row" data-aos="fade-up" data-aos-delay="100">
        <div className="subscribe-container">
          <div className="col s12 l4">
            <h4 className="title p-b-2">Subscribe</h4>
          </div>
          {/*<!-- Subscription Form -->*/}
          <form
            id="subscribe-form"
            name="subscribe-form"
            className="subscribe-input input-field col s12 l8"
            data-netlify="true"
          >
            {/*<!-- Email Field -->*/}
            <input
              name="subscribe-email"
              id="subscribe-email"
              type="email"
              className="validate"
            />
            <label data-error="Invalid Email" htmlFor="subscribe-email">
              Email
            </label>
            {/*<!-- Submit Button -->*/}
            <button
              id="subscribe-submit"
              className="gradient-color waves-effect waves-light"
              type="submit"
            >
              <i className="fa fa-paper-plane first" />

              <i className="fa fa-paper-plane second" />
            </button>
            {/*<!-- ! Anti-spam field ! Invisible for users, it will trick most bots to fill it and prevent the email from being sent to you -->*/}
            <div className="input-field col s12 hidden">
              <input
                type="text"
                id="subscribe-check-spam"
                placeholder="Leave field empty"
                name="check-spam"
              />
            </div>
          </form>
        </div>

        {/*<!-- Alert Message -->*/}
        <div
          className="col s12 alert-message p-t-2"
          id="subscribe-alert-message"
        />
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/SubscribeSection.js